import { Component, Input } from '@angular/core';
import { SkeletonBase } from './SkeletonBase';

@Component({
  template: ''
})
// tslint:disable-next-line:component-class-suffix
export class SkeletonSizeBase extends SkeletonBase {
  @Input('skc-width') width;
  @Input('skc-height') height;
}
